import type { Program, ProgramEventContentObjectList } from 'models';
import { Trans, useTranslation } from 'react-i18next';
import { Flex, Image, Text } from 'ui';
import { CalendarIcon } from '../../../calendar-icon';

type P = {
  item: ProgramEventContentObjectList;
  program: Program;
};

/**
 * @deprecated AI-generated code, not reviewed. Needs revision before further use — do not use as a reference or pattern to follow.
 */
const EventContent = ({ item, program }: P) => {
  const { t } = useTranslation();
  const { event } = item;

  return (
    <Flex gap={16} vertical>
      {event.coverPhoto ? <Image alt="event cover" preview={false} src={event.coverPhoto.url} /> : null}
      <Flex gap={24}>
        <CalendarIcon time={event.startTime.toISOString()} />
        <Flex gap="xxs" vertical>
          <Flex gap="xxs">
            <Text type="secondary">{t('dateFormats.shortMonthDayYear', { date: event.startTime })} •</Text>
            <Text type="danger">{t('dateFormats.time', { date: event.startTime })}</Text> –{' '}
            <Text type="secondary">{t('dateFormats.shortMonthDayYear', { date: event.endTime })} •</Text>
            <Text type="danger">{t('dateFormats.time', { date: event.endTime })}</Text>
          </Flex>
          <Text size="small">
            <Trans>Hosted by</Trans> {program.authorName}
          </Text>
          <Text size="small">{event.viewPermission}</Text>
        </Flex>
      </Flex>
    </Flex>
  );
};

export default EventContent;
